// extracted by mini-css-extract-plugin
export var updateLicenseModal = "update-license-modal_MFvCo_B0V6D_tg1gl1LM";
export var updateLicenseModalAccessModules = "update-license-modal__access-modules__sJYuzGGZ01jM__59bMr";
export var updateLicenseModalLicensePreset = "update-license-modal__license-preset_oh0pv_6vcPFxnx82er1T";
export var updateLicenseModalLicensePresetMessage = "update-license-modal__license-preset-message_Zk7DqJuSQZzqdz6paABB";